import config from '@/config';

export const devWarning = (warning: string) => {
  if (config.isDevelopment || config.isTest) {
    // biome-ignore lint/suspicious/noConsole: Needed for debugging
    console.log(`Dev warning: %c${warning}`, 'color: #EB4762;');
  }
};

export const devLog = (log: string, variables: Record<string, unknown>) => {
  if (config.isDevelopment || config.isTest) {
    // biome-ignore lint/suspicious/noConsole: Needed for debugging
    console.log(`Dev log: %c${log}`, 'color: #03CFA5;', variables || '');
  }
};
